import request from '@/utils/request'

// 获取企业微信 appId
export function getQywxAppId(appId) {
  return request({
    method: 'POST',
    url: `/getQywxAppId/${appId}`
  })
}

// 登录
export function login(data) {
  return request({
    method: 'POST',
    url: '/qywxLogin',
    data
  })
}
// 获取corpSecret
export function getCorpSecret(data) {
  return request({
    method: 'POST',
    url: '/getQywxAppIdInfo',
    data
  })
}
// 获取用户信息
export function getInfo() {
  return request({
    method: 'get',
    url: '/getInfo'
  })
}

// 获取路由
export const getRouters = () => {
  return request({
    url: '/getRouters',
    method: 'get',
    options: {
      loading: true,
      loadingText: '页面加载中'
    }
  })
}

// 获取路由新
export const getRoutersNew = (query) => {
  return request({
    url: '/getRoutersMb',
    method: 'get',
    params: query,
    options: {
      loading: true,
      loadingText: '页面加载中'
    }
  })
}

// 获取企微信用信息
export function getWxConfig(data) {
  return request({
    method: 'POST',
    url: '/getWxConfig',
    data
  })
}

// 获取消息跳转详细地址
export const getNewsPath = (messageLogId) => {
  return request({
    url: '/system/messageLog/getURL?messageLogId=' + messageLogId,
    method: 'get',
    options: {
      loading: true,
      loadingText: '页面加载中'
    }
  })
}
